import { CustomRule, RequiredRule, Validator } from 'devextreme-react/validator';
import { DateBox } from 'devextreme-react/date-box';
import { useContext } from 'react';
import { Field, Panel } from '../../../../layouts';
import { AR, OrderStatus } from '../../../../types/enums';
import { PurchaseOrderContext } from '../context/PurchaseOrderContext';
import { formatShortDate } from '../../../../utils/date-utils';

export default function ValidateShipDatePanel() {

	const { order, modifyOrder } = useContext(PurchaseOrderContext);

	const isOrderReadonly = order.details.orderStatusID === OrderStatus.Closed ||
		order.details.orderStatusID === OrderStatus.Cancelled;

	const isReadOnly = !order.details.activeARs.includes(AR.PODistributorToValidateShipDate) || isOrderReadonly;
	const isRequired = !isReadOnly;

	return (
		<Panel header={'Dates'} >
			<Field label="Requested Ship Date">
				{formatShortDate(order.details.requestedShipDate)}
			</Field>
			<Field label="Validated Ship Date" >
				<DateBox value={order.details.validatedShipDate}
					onValueChanged={(e) => modifyOrder({ ...order.details, validatedShipDate: e.value })}
					readOnly={isReadOnly}
					className={isRequired ? 'required' : ''}>
					<Validator>
						{
							isRequired && order.modified &&
							<RequiredRule message={'Validated Ship Date is required'} />
						}
						<CustomRule
							validationCallback={(data) => {
								if (order.details.requestedShipDate)
									return new Date(data.value) >= order.details.requestedShipDate;
								else
									return true;
							}}
							message="Validate Ship Date must be greater or equal than Requested Ship Date"
						/>
					</Validator>
				</DateBox>
			</Field>
		</Panel>
	);
}
